<template>
  <div class="scroll">
    <card>
      <div v-for="f in staticFilters" :key="f.key">
        <label>{{ f.title }}</label>
        <radio-list :name="`${f.key}-filter`" v-model="params[f.key]" :items="f.items" @input="params['page'] = 1" />
      </div>
      <div v-if="params['day'] == 2">
        <selector :title="`Выберите учебный год (обязательно)`" :prefix="`season`" :modal="'season'"
          :selectKey="'title'" v-model="params['season']" />
      </div>
      <list v-if="init" :columns="columns" :modalCreate="modalCreate" :additionalId="`${group_id}-${discipline_id}`" :removeLink="removeLink" :cardLink="cardLink"
        :params="params" :isUpdate="true" :isAdd="false" :itemLink="itemLink" :setLink="setLink" :fields="fields"
        :searchDisable="false" @change="change" @changeFunction="changeFunction" v-model="val" />
    </card>
  </div>
</template>
<script>
export default {
  props: {
    group_id: {
      default: null
    },
    discipline_id: {
      default: null
    },
  },
  created() {
    this.itemLink = `business/teacher_groups/${this.group_id}/journals/${this.discipline_id}/lessonplans`;
  },
  watch: {
    discipline_id(val) {
      this.init = false;
      this.itemLink = `business/teacher_groups/${this.group_id}/journals/${val}/lessonplans`;
      setTimeout(() => {
        this.init = true;
      }, 10)
    }
  },
  name: "timetables",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      season: null,
      staticFilters: [
     
      ],
      init: true,
      params: {},
      filters: [
        {
          key: "course",
          title: "Номер Класса",
        },
        {
          key: "discipline",
          title: "Дисциплина",
        },
      ],
      val: [],
      /**START ADD ITEM */
      modalCreate: "timetable",
      fields: [

      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_decision",
      itemLink: "",
      setLink: "",
      /** COLUMNS MODEL */
      columns: [
 
        {
          key: "title",

          title: "Название",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "position",

          title: "Плановый урок",
 
          checkbox: false,
          full: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },


        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
.scroll {
  position: absolute;
  overflow: scroll;
  width: 100%;
  height: 100%;
}
</style>
